import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons'
import React, { useCallback } from 'react'
import { flushSync } from 'react-dom'
import { RectangularInputFormatNumberSmall } from '..'
import TwinIcon from '../../../baseComponents/TwinIcon'
import useMyDebounce from '../../../utils/hooks/useMyDebounce'
import './inputquantitybuttons.sass'

export interface InputQuantityButtonsProps extends InputQuantityButtonsLogicProps {}

const InputQuantityButtons: React.FC<InputQuantityButtonsProps> = ({value, onChange, readOnly, ...logic}) => {
    const { changeMyValue, myValue, ref, myOnBlur } = useMyDebounce({ value: String(value || '0'), onChange, readOnly, isNumber: true, timeDebounce: 400})
    const { changeValue } = useInputQuantityButtonsLogic({value, onChange, readOnly, ...logic})
    return (
        <div className='flex input_quantity_buttons'>
            <SmallQuantityButton onClick={() => changeValue(false)}><TwinIcon icon={faMinus} fontSize={11}/></SmallQuantityButton>
            <RectangularInputFormatNumberSmall minValue={logic.minQuantity} maxValue={logic.maxQuantity} className='flex-auto mx-6' value={readOnly && !myValue ? '' : myValue} onChange={changeMyValue} readOnly={readOnly} onBlur={myOnBlur} myref={ref}/>
            <SmallQuantityButton onClick={() => changeValue(true)}><TwinIcon icon={faPlus} fontSize={11}/></SmallQuantityButton>
        </div>
    )
}
interface InputQuantityButtonsLogicProps {
    value: number | string
    onChange: (value: string) => void
    readOnly?: boolean
    minQuantity?: number
    maxQuantity?: number
}
export interface SmallQuantityButtonProps {
    onClick: React.MouseEventHandler
    children: React.ReactNode
}

export const SmallQuantityButton: React.FC<SmallQuantityButtonProps> = ({onClick, children}) => {
    return (
        <div className='bg-gray-EF rounded-md flex justify-center items-center h-29 w-31 min-w-31 cursor-pointer small_quantity_button' onClick={onClick}>{children}</div>
    )
}

const useInputQuantityButtonsLogic = ({value, onChange, readOnly, minQuantity, maxQuantity}: InputQuantityButtonsLogicProps) => {
    const changeValue = useCallback((increase: boolean) => {
        if(!readOnly){
            flushSync(async () => {
                let newValue = value ? parseFloat(String(value)) : 0;
                const myMinQuantity = parseFloat(String(minQuantity || 0))
                const myMaxQuantity = maxQuantity ? parseFloat(String(maxQuantity)): Infinity
                if (increase) {
                    newValue +=1
                } else {
                    if (newValue > 0) {
                        newValue-=1
                    }
                }
                if(myMinQuantity<=newValue && myMaxQuantity>=newValue){
                    onChange?.(String(newValue))
                }
            })
        }
    }, [onChange, readOnly, value, minQuantity, maxQuantity])

    return { changeValue }
}


export default InputQuantityButtons